// import moment from "moment/moment"

// class DateHelper {
//   constructor(date) {
//     this.date = moment(date)
//   }

//   addYears(years) {
//     this.date.add(years, "years")
//     return this
//   }

//   subtractYears(years) {
//     this.date.subtract(years, "years")
//     return this
//   }

//   addMonths(months) {
//     this.date.add(months, "months")
//     return this
//   }

//   subtractMonths(months) {
//     this.date.subtract(months, "months")
//     return this
//   }

//   addDays(days) {
//     this.date.add(days, "days")
//     return this
//   }

//   subtractDays(days) {
//     this.date.subtract(days, "days")
//     return this
//   }

//   addHours(hours) {
//     this.date.add(hours, "hours")
//     return this
//   }

//   subtractHours(hours) {
//     this.date.subtract(hours, "hours")
//     return this
//   }

//   addMinutes(minutes) {
//     this.date.add(minutes, "minutes")
//     return this
//   }

//   subtractMinutes(minutes) {
//     this.date.subtract(minutes, "minutes")
//     return this
//   }

//   addSeconds(seconds) {
//     this.date.add(seconds, "seconds")
//     return this
//   }

//   subtractSeconds(seconds) {
//     this.date.subtract(seconds, "seconds")
//     return this
//   }

//   toDate() {
//     return this.date.toDate()
//   }
// }
function formatDate(date, format = "YYYY-MM-DD") {
  return moment(date).format(format)
}
function createFormData(data) {
  const formData = new FormData()

  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      const value = data[key]

      if (Array.isArray(value)) {
        for (const item of value) {
          formData.append(key, item)
        }
      } else if (value instanceof FileList) {
        for (const item of value) {
          formData.append(key, item)
        }
      } else if (typeof value === "Object") {
        formData.append(key, JSON.stringify(value))
      } else value && formData.append(key, value)
    }
  }

  return formData
}
function objectToQueryString(obj) {
  return Object.keys(obj)
    .filter(key => obj[key])
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
    .join("&")
}

const getCurrentURLParameters = () => {
  const searchParams = new URLSearchParams(window.location.search)
  const params = {}
  for (const [key, value] of searchParams) {
    params[key] = value
  }
  return params
}

/** Email links often contain HTML-encoded ampersands (&amp;) which break query parsing. */
const normalizeAuthSearch = (search = "") =>
  search.replace(/&amp;/gi, "&").replace(/&#38;/gi, "&")

/**
 * Read uid/token from activation or password-reset email links.
 * Supports legacy `id` param and malformed `amp;token` from un-decoded &amp; in URLs.
 */
const getAuthLinkParams = (search = window.location.search) => {
  const normalized = normalizeAuthSearch(search)
  const params = new URLSearchParams(normalized)
  const uid = (params.get("uid") || params.get("id") || "").trim()
  const token = (params.get("token") || params.get("amp;token") || "").trim()
  return { uid, token }
}
const getURLQuery = () => {
  const searchParams = new URLSearchParams(window.location.search)
  const params = {}
  for (const [key, value] of searchParams) {
    params[key] = value
  }
  return params
}
const copyToClipboard = text => {
  const textarea = document.createElement("textarea")
  textarea.value = text
  document.body.appendChild(textarea)
  textarea.select()
  document.execCommand("copy")
  document.body.removeChild(textarea)
}
const getRandomColor = () => {
  return `rgb(${Math.floor(Math.random() * 256)}, ${Math.floor(
    Math.random() * 256
  )}, ${Math.floor(Math.random() * 256)})`
}
import { formatPrice } from "../utils/saleUtils";

const getAsBool = value => {
  return value === "true" || value === "True"
}
const formattedPrice = formatPrice;
const dataURLtoBlob = (dataurl) => {
  const arr = dataurl.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
};
const imageToBlob = (image) => {

  
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      canvas.width = image?.width;
      canvas.height = image?.height;
      const ctx = canvas.getContext('2d');
      if (ctx) {
        ctx.drawImage(image, 0, 0);
        canvas.toBlob((blob) => {
          if (blob) {
            resolve(blob);
          } else {
            throw new Error('Failed to convert image to Blob.');
          }
        });
      } else {
        throw new Error('Failed to get 2D context from canvas.');
      }
    });
  };
function TypeCheck(value) {
  return {
    isUndefined: () => typeof value === "undefined",
    isNull: () => value === null,
    isBoolean: () => typeof value === "boolean",
    isNumber: () => typeof value === "number",
    isString: () => typeof value === "string",
    isObject: () => typeof value === "object",
    isArray: () => Array.isArray(value),
    isObjectNotArray: () => typeof value === "object" && !Array.isArray(value),
    isFunction: () => typeof value === "function",
    isSymbol: () => typeof value === "symbol",
    isBigInt: () => typeof value === "bigint"
  }
}

const extractId = dataObj => {
  if (TypeCheck().isObjectNotArray(dataObj)) return dataObj._id
  else return dataObj
}
const dataURLtoFile = (dataurl, filename) => {
  // Split the data URL into components
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  
  // Create a Uint8Array from the binary string
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  
  // Create a file from the Uint8Array and return it
  return new File([u8arr], filename, { type: mime });
};
export {
  createFormData,
  // DateHelper,
  imageToBlob,
  formatDate,
  objectToQueryString,
  getCurrentURLParameters,
  getAuthLinkParams,
  copyToClipboard,
  getRandomColor,
  getAsBool,
  formattedPrice,
  TypeCheck,
  extractId,
  getURLQuery,
  dataURLtoFile
}
